import "./assets/www_app-10.png";
import "./assets/wx-10.png";
require("./aside.less");